import { defineStore } from 'pinia'
import dayjs from 'dayjs'
import minMax from 'dayjs/plugin/minMax'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isBetween from 'dayjs/plugin/isBetween'

import state from './state'
import { getters as rootGetters, actions as rootActions } from './modules/root'
import { getters as featuresGetters, actions as featuresActions } from './modules/features'
import { getters as skillsGetters, actions as skillsActions } from './modules/skills'
import { getters as ratingsGetters, actions as ratingsActions } from './modules/ratings'
import {
  getters as sponsorshipsGetters,
  actions as sponsorshipsActions,
} from './modules/sponsorships'
import { getters as sponsorsGetters, actions as sponsorsActions } from './modules/sponsors'
import { getters as placementsGetters, actions as placementsActions } from './modules/placements'
import { getters as clientsGetters, actions as clientsActions } from './modules/clients'
import { getters as engagementsGetters, actions as engagementsActions } from './modules/engagements'
import {
  getters as staffingRolesGetters,
  actions as staffingRolesActions,
} from './modules/staffingRoles'
import { getters as usersGetters, actions as usersActions } from './modules/users'

dayjs.extend(isSameOrBefore)
dayjs.extend(minMax)
dayjs.extend(isBetween)

export * from './constants'
export { sortedPlacements } from './helpers'

export const useStore = defineStore('main', {
  state,
  getters: {
    ...rootGetters,
    ...featuresGetters,
    ...skillsGetters,
    ...ratingsGetters,
    ...sponsorshipsGetters,
    ...sponsorsGetters,
    ...placementsGetters,
    ...clientsGetters,
    ...engagementsGetters,
    ...staffingRolesGetters,
    ...usersGetters,
  },
  actions: {
    ...rootActions,
    ...featuresActions,
    ...skillsActions,
    ...ratingsActions,
    ...sponsorshipsActions,
    ...sponsorsActions,
    ...placementsActions,
    ...clientsActions,
    ...engagementsActions,
    ...staffingRolesActions,
    ...usersActions,
  },
})

export default useStore
